import { render } from "./chatWindowMaximized.vue?vue&type=template&id=69b07473&scoped=true"
import script from "./chatWindowMaximized.vue?vue&type=script&lang=js"
export * from "./chatWindowMaximized.vue?vue&type=script&lang=js"

import "./chatWindowMaximized.vue?vue&type=style&index=0&id=69b07473&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b07473"]])

export default __exports__